import { a } from './chunk-CPA2WHX5.mjs';
import { e } from './chunk-VSVXN4DE.mjs';
import { jsx } from 'react/jsx-runtime';

var t=e(a());var l=({children:i,className:e})=>jsx("div",{className:(0, t.default)("ui-inline-flex ui-align-middle",e),children:i});

export { l as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-T6K6XLYD.mjs.map